<template>
    <div :id="idComponente">
        <div class="form-group">
            <h6 :for="'catalogo-plantillas' + idComponente">Plantillas de documento</h6>
            <C009TiposPlantilla class="p-0 m-0" :id="'catalogo-plantillas' + idComponente"
                v-on:valorParaElPadre="evtCambioTipoCedula" 
                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                :idDelInput="'CTC' + idComponente" 
                :parametros="filtrosDePlantillas"
                :valorDefinido="valorDefinidoCatalogo"
                :key="'KCT' + idComponente + contadorRender"></C009TiposPlantilla>
            <div v-if="plantillaSeleccionada != null">
                <h6 :for="'input-plantilla-elegida' + idComponente">Plantilla elegida</h6>
                <div class="contenedor-plantilla" :id="'input-plantilla-elegida' + idComponente">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex justify-content-between align-items-center">
                            <i class="fas fa-file-alt mr-2" style="font-size: 23px;"></i>
                            <span style="color: #000000; font-weight: bold;">{{ plantillaSeleccionada.Nombre }}</span>
                        </div>
                        <div>
                            <button v-if="verDescripcionPlantilla" @click="verDescripcionPlantilla = true" type="button" class="btn btn-primary"><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Descripcion</button>
                            <button v-if="verDescripcionPlantilla" @click="verDescripcionPlantilla = false" type="button" class="btn btn-primary"><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Ocultar</button>
                            <button v-if="verDescripcionPlantilla" @click="descargarPlantilla" type="button" class="btn btn-primary"><i class="fas fa-file-download"></i>&nbsp;&nbsp;Descargar</button>
                        </div>
                    </div>
                    <div v-if="verDescripcionPlantilla" class="mt-2">
                        <textarea disabled v-model="informacionPlantillas" rows="4" type="text" class="form-control" style="color: #ffffff"/>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="conSubidorDeArchivo" class="form-group mt-4">
            <h6 :for="'input-archivoDeResultado' + idComponente">Archivo para {{ eleccionPara }}&nbsp;
                <i v-if="mostrarErrores && this.archivoParaSubirEsValido()" class="fas fa-check-circle text-success font-size: 15px;"></i>
                <i v-if="mostrarErrores && !this.archivoParaSubirEsValido()" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
            <input type="file" :id="'input-archivoDeResultado' + idComponente" :class="[mostrarErrores && !this.archivoParaSubirEsValido() ? 'form-control border border-danger' : 'form-control']" v-on:change="evtAgregarDocumentoResultado($event)" :accept="archivoSubirExtensionesValidas" />
            <div class="form-group mt-3">
                <PDFDocument v-if="archivoParaSubir != null"
                    :url="''" 
                    :height="'400px'" 
                    :ArchivoAConvertir="archivoParaSubir" 
                    :key="'KVD' + idComponente + contRenderVisorDocumentos"/>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'

export default {
    props: {
        idComponente: String,
        filtrosDePlantillas: Object,
        eleccionPara: String,
        archivoSubirExtensionesValidas: {
            default: '.DOC,.DOCX,.PDF',
            type: String
        },
        valorDefinidoCatalogo: {
            default: -1,
            type: Number
        },
        contadorRender: {
            default: 0,
            type: Number
        },
        archivoParaSubir: {
            default: null,
            type: File
        },
        mostrarErrores: {
            default: false,
            type: Boolean
        },
        conSubidorDeArchivo: {
            default: false,
            type: Boolean
        }
    },
    components: {
        C009TiposPlantilla: catalogos.SINOJ.C009TiposPlantilla,
        PDFDocument
    },
    data() {
        return {
            enumeraciones,
            mostrarInformacionDePlantilla: false,
            nombrePlantillaElegida: null,
            verDescripcionPlantilla: false,
            plantillaSeleccionada: null,
            informacionPlantillas: null,
            contRenderVisorDocumentos: 0
        }
    },
    methods: {
        descargarPlantilla: function() {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.plantillaSeleccionada.Ruta}`
            a.click();
        },
        evtCambioTipoCedula: function(evento,tipoPlantillaObj) {
            this.informacionPlantillas = null;
            this.plantillaSeleccionada = tipoPlantillaObj;
            if(this.plantillaSeleccionada != null) {
                //this.informacionPlantillas = `[${this.plantillaSeleccionada.Area.Nombre}]\n${this.plantillaSeleccionada.Descripcion}`
            }
            this.verDescripcionPlantilla = false;
            this.$emit('obtenerPlantilla', tipoPlantillaObj); 
        },
        archivoParaSubirEsValido: function() {
            let archivoValido = false;
            if(this.archivoParaSubir != null && this.archivoParaSubir != undefined) 
                archivoValido = true
            return archivoValido;
        },
        evtAgregarDocumentoResultado: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    //console.log('a::',evento.target.files[0])
                    this.archivo_subir = evento.target.files[0];
                    this.contRenderVisorDocumentos ++;
                }
                else {
                    this.archivo_subir = null;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        limpiarInputArchivo: function() {
            $("#input-archivoDeResultado" + this.idComponente).val('');
            this.archivo_subir = null;
            this.verDescripcionPlantilla = false;
            this.contador_render ++;
            this.plantillaSeleccionada = null;
        },

    },
    computed: {
        valorDefino_catalogo: {
            get() {
                return this.valorDefinidoCatalogo;
            },
            set(val) {
                this.$emit('obtValorDefinidoCatalogo', val);
            }
        },
        contador_render: {
            get() {
                return this.contadorRender;
            },
            set(val) {
                this.$emit('obtContadorRender', val);
            }
        },
        filtros_catalogo: {
            get() {
                return this.filtrosDePlantillas;
            },
            set(val) {
                this.$emit('obtFiltrosDePlantillas', val);
            }
        },
        eleccion_para: {
            get() {
                return this.eleccionPara;
            },
            set(val) {
                this.$emit('obtEleccionPara', val);
            }
        },
        archivo_subir: {
            get() {
                return this.archivoParaSubir;
            },
            set(val) {
                this.$emit('obtArchivoASubir', val);
            }
        },
        mostrar_errores: {
            get() {
                return this.mostrarErrores;
            },
            set(val) {
                this.$emit('obtMostrarErrores', val);
            }
        }
    }
}
</script>
<style scoped>

.contenedor-plantilla {
    padding: 5px 9px 5px 9px;
    border-radius: 4px;
    background-color: #817c7c;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CEleccionDePlantilla.vue